export { default as EditColor } from "./edit-color.vue";
export * from "./IEditColor";